import { mapGetters } from 'vuex';

export default {
    name: 'dspRecord',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp']),
        getSchoolDistrict(){
            var schoolDistrict = this.dsp && this.dsp.districtName && this.dsp.districtName.replace('School District', '');
            return schoolDistrict;
        }
    }
};